export const cEstadoPicking = [
    {estadoId: 2001, nombre: "Disponible", }
    ,
    {estadoId: 2002, nombre: "En curso", }
    ,
    {estadoId: 2003, nombre: "Finalizado", }
]
